var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("vue-plyr", { key: _vm.id, ref: "plyr" }, [
        _c(
          "video",
          {
            ref: "player",
            attrs: { playsinline: "", "webkit-playsinline": "", id: "player" }
          },
          [_c("source", { attrs: { src: _vm.getResource, type: _vm.getType } })]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }